export default "__VITE_ASSET__WKzYfcCH__"